import { Navigate, Route, Routes } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { SettingsSectionLayout, SettingsWIP } from '../components/Layout/Layout';

export const Tools = () => {
  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.tools">Tools</Trans>}
      basePath="/settings_beta/support/tools"
      tabs={[
        {
          id: 'external-entities',
          label: <Trans id="support.entities.external-entities">External entities</Trans>,
        },
        {
          id: 'external-groups',
          label: <Trans id="support.entities.external-groups">External groups</Trans>,
        },
      ]}
    >
      <Routes>
        <Route path="external-entities" element={<SettingsWIP />} />
        <Route path="external-groups" element={<SettingsWIP />} />
        <Route
          path="*"
          element={<Navigate to="/settings_beta/support/tools/external-entities" replace />}
        />
      </Routes>
    </SettingsSectionLayout>
  );
};
